import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Webcam from 'react-webcam';
import { Layout } from '../components/Layout/Layout';
import { Button } from '../components/common/Button';
import { LogoBox } from '../components/common/LogoBox';
import Timer from '../components/common/Timer';
import { useNavigation } from '../hooks/useNavigation';
import { SHOT_CONFIG } from '../constants/shotConfig';
import { useTimeoutHandler } from '../hooks/useTimeoutHandler.ts';
import { getDevShotTime } from '../utils/util';
import { RootState } from '../store/store';
import { setShotCount } from '../store/photoSlice';
import { AiLoadingText, Container, DashedBox, ShotInfoBox, ShotInfo, WebcamWrapper } from './StandbyPage.styled';

const dotList = ['.', '..', '...'];

export function StandbyPage() {
  const { t } = useTranslation();
  const { navigateToShot } = useNavigation();
  const dispatch = useDispatch();
  const [dotIdx, setDotIdx] = useState<number>(0);
  const [isWebcamReady, setIsWebcamReady] = useState<boolean>(false);
  const { handleStandbyTimeout } = useTimeoutHandler();
  const { block } = useSelector((state: RootState) => state.block);
  const { selectedThemeId } = useSelector((state: RootState) => state.theme);

  const selectedTheme = block?.themes?.find((theme) => theme.id === selectedThemeId);
  // BLK_001 블록은 8회 촬영으로 강제 설정
  const shotCount = block?.blockCode === 'BLK_001' ? 8 : (selectedTheme?.shotCount || SHOT_CONFIG.DEFAULT_SHOT_COUNT);

  useEffect(() => {
    dispatch(setShotCount(shotCount));
  }, [shotCount, dispatch]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (!isWebcamReady) {
      intervalId = setInterval(() => {
        setDotIdx((prevIdx) => (prevIdx + 1) % 3);
      }, 500);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isWebcamReady]);

  return (
    <Layout>
      {isWebcamReady && <Timer initialTime={20} onTimeout={handleStandbyTimeout} />}
      <Container>
        <LogoBox />
        <DashedBox>
          {!isWebcamReady && (
            <p>
              {t('standby.preparing')}
              {dotList[dotIdx]}
            </p>
          )}
          {isWebcamReady && <p>{t('standby.ready')}</p>}
          <AiLoadingText>{t('standby.checkCamera')}</AiLoadingText>
          <ShotInfoBox>
            <ShotInfo>
              <h3>{t('standby.shotCount', { count: shotCount })}</h3>
              <h3>{t('standby.shotTime', { time: getDevShotTime(block?.blockCode, block?.subFolder) })}</h3>
              <Button onClick={navigateToShot} disabled={!isWebcamReady}>
                {t('standby.start')}
              </Button>
            </ShotInfo>
            <WebcamWrapper>
              <Webcam
                audio={false}
                height={300}
                width={240}
                videoConstraints={SHOT_CONFIG.VIDEO_CONSTRAINTS}
                onUserMedia={() => setIsWebcamReady(true)}
              />
            </WebcamWrapper>
          </ShotInfoBox>
          {/* <Description>
            촬영 시작 전, 카메라 사용 허용 여부와 네트워크 상태를 꼭
            확인해주세요.
          </Description> */}
        </DashedBox>
      </Container>
    </Layout>
  );
}
